import { render, staticRenderFns } from "./base-tooltip.vue?vue&type=template&id=53824295"
import script from "./base-tooltip.ts?vue&type=script&lang=ts&external"
export * from "./base-tooltip.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports